import _ from "lodash";
import { IeLynxObject } from "../../../common/models/eLynxObject";
import { DashboardComponentTypeEnum, DashboardTemplateObjectTypeEnum, IDashboardComponent, IDashboardTemplateDefinition, IDeviceMarketingReportDashboardComponent, ITagValueListDashboardComponent } from "../../../services/dashboard-data-service/Models";
import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";

export const DragDropTypes = {
    Section: 'section',
    Row: 'row',
    Column: 'column',
    Graph: 'graph',
    AlarmNotificationCountChart: 'alarm-notification-count-chart',
    TagValueList: 'tag-value-list',
    TagValueGrid: 'tag-value-grid',
    SummaryListing: 'summary-listing',
    TankBattery: 'tank-battery',
    AlarmBanner: 'alarm-banner',
    DeviceMarketingReport: 'device-marketing-report',
    Report: 'report',
    Mapping: 'mapping',
    ImageView: 'image-view',
    HistoricalData: 'historical-data',
    ObjectHistory: 'object-history',
    ObjectProperties: 'object-properties',
    ObjectTagValues: 'object-tag-values',
};
  
const DashboardRunnerUtils = {

  updateModelContext: (item: IDashboardTemplateDefinition, 
    contextGroupID: number, 
    contextObject: IeLynxObject ): IDashboardTemplateDefinition => {

    //   function updateDefinition(section: IDashboardSection) {

    //     section.rows.forEach(row => {
    //         row.columns.forEach(column => {
    //             column.components.forEach(component => {

    //                 switch (component.componentType) {
    //                     case DashboardComponentTypeEnum.Section:
    //                         updateDefinition(component as IDashboardSection)
    //                         break;

    //                     case DashboardComponentTypeEnum.SummaryListing:
    //                     case DashboardComponentTypeEnum.Reporting:
    //                     case DashboardComponentTypeEnum.AlarmDrawer:   
    //                     case DashboardComponentTypeEnum.ImageView:                         
    //                     case DashboardComponentTypeEnum.Mapping: 

    //                         if (component.objectID) {
    //                             component.groupID = component.objectID;
    //                             component.contextObject = {
    //                                 id: component.objectID,
    //                                 objectType: eLynxObjectTypeEnum.Group
    //                             };
    //                         } else {
    //                             component.groupID = contextGroupID;
    //                             component.contextObject = contextObject;
    //                         }
        
                            
    //                         break;

    //                         case DashboardComponentTypeEnum.DeviceMarketingReport: {

    //                             const marketingReport = component as IDeviceMarketingReportDashboardComponent;
        
    //                             if (marketingReport.objectID) {
    //                                 //marketingReport.groupID = marketingReport.groupID;
    //                                 marketingReport.contextObject = {
    //                                     id: marketingReport.objectID,
    //                                     objectType: eLynxObjectTypeEnum.Device
    //                                 };
    //                             } else {
    //                                 marketingReport.groupID = contextGroupID;
    //                                 marketingReport.contextObject = contextObject;
    //                             }
        
    //                         }
    //                         break;

    //                     case DashboardComponentTypeEnum.TagValueList: {
    //                             component.groupID = contextGroupID;
        
    //                             const tagValueComponent = component as ITagValueListDashboardComponent;
    //                             tagValueComponent.configuration.forEach(o => {
    //                                 o.objects = [contextObject!];
    //                             });
    //                         }
    //                         break;

    //                     default: {
    //                         component.groupID = contextGroupID;

    //                         if (component.objectID && component.objectType) {
    //                             component.contextObject = {
    //                                 id: component.objectID,
    //                                 objectType: component.objectType
    //                             };
    //                         } else {
    //                             component.contextObject = contextObject;
    //                         }                            
    //                     }
    //                 }


    //                 // if (component.componentType === DashboardComponentTypeEnum.Section) {
    //                 //     updateDefinition(component as IDashboardSection)
    //                 // } else if (component.componentType === DashboardComponentTypeEnum.SummaryListing){
    //                 //     const summaryComponent = component as ISummaryListingDashboardComponent;

    //                 //     if (summaryComponent.objectID) {
    //                 //         summaryComponent.groupID = summaryComponent.objectID;
    //                 //         summaryComponent.contextObject = {
    //                 //             id: summaryComponent.objectID,
    //                 //             objectType: eLynxObjectTypeEnum.Group
    //                 //         };
    //                 //     } else {
    //                 //         summaryComponent.groupID = contextGroupID;
    //                 //         summaryComponent.contextObject = contextObject;
    //                 //     }

    //                 // } else if (component.componentType === DashboardComponentTypeEnum.AlarmDrawer) {

    //                 //     const alarmDrawer = component as IAlarmDrawerDashboardComponent;

    //                 //     if (alarmDrawer.objectID) {
    //                 //         alarmDrawer.groupID = alarmDrawer.objectID;
    //                 //         alarmDrawer.contextObject = {
    //                 //             id: alarmDrawer.objectID,
    //                 //             objectType: eLynxObjectTypeEnum.Group
    //                 //         };
    //                 //     } else {
    //                 //         alarmDrawer.groupID = contextGroupID;
    //                 //         alarmDrawer.contextObject = contextObject;
    //                 //     }

    //                 // } else if (component.componentType === DashboardComponentTypeEnum.DeviceMarketingReport) {

    //                 //     const marketingReport = component as IDeviceMarketingReportDashboardComponent;

    //                 //     if (marketingReport.objectID) {
    //                 //         //marketingReport.groupID = marketingReport.groupID;
    //                 //         marketingReport.contextObject = {
    //                 //             id: marketingReport.objectID,
    //                 //             objectType: eLynxObjectTypeEnum.Device
    //                 //         };
    //                 //     } else {
    //                 //         marketingReport.groupID = contextGroupID;
    //                 //         marketingReport.contextObject = contextObject;
    //                 //     }

    //                 // } else if (component.componentType === DashboardComponentTypeEnum.Reporting){
    //                 //     const reportComponent = component as IReportingDashboardComponent;

    //                 //     if (reportComponent.objectID) {
    //                 //         reportComponent.groupID = reportComponent.objectID;
    //                 //         reportComponent.contextObject = {
    //                 //             id: reportComponent.objectID,
    //                 //             objectType: eLynxObjectTypeEnum.Group
    //                 //         };
    //                 //     } else {
    //                 //         reportComponent.groupID = contextGroupID;
    //                 //         reportComponent.contextObject = contextObject;
    //                 //     }

    //                 // } else if (component.componentType === DashboardComponentTypeEnum.Mapping){
    //                 //     const mappingComponent = component as IMappingDashboardComponent;

    //                 //     if (mappingComponent.objectID) {
    //                 //         mappingComponent.groupID = mappingComponent.objectID;
    //                 //         mappingComponent.contextObject = {
    //                 //             id: mappingComponent.objectID,
    //                 //             objectType: eLynxObjectTypeEnum.Group
    //                 //         };
    //                 //     } else {
    //                 //         mappingComponent.groupID = contextGroupID;
    //                 //         mappingComponent.contextObject = contextObject;
    //                 //     }


    //                 // } else if (component.componentType === DashboardComponentTypeEnum.TagValueList) {
    //                 //     component.groupID = contextGroupID;

    //                 //     const tagValueComponent = component as ITagValueListDashboardComponent;
    //                 //     tagValueComponent.configuration.forEach(o => {
    //                 //         o.objects = [contextObject!];
    //                 //     });
    //                 // } else {
    //                 //     component.groupID = contextGroupID;

    //                 //     if (component.objectID && component.objectType) {
    //                 //         component.contextObject = {
    //                 //             id: component.objectID,
    //                 //             objectType: component.objectType
    //                 //         };
    //                 //     } else {
    //                 //         component.contextObject = contextObject;
    //                 //     }
    //                 // }
    //             });
    //         });
    //     });
    //   }

      function updateDefinition(components: IDashboardComponent[], groupLevel: boolean) {

        components.forEach(component => {

            switch (component.componentType) {

                case DashboardComponentTypeEnum.SummaryListing:
                case DashboardComponentTypeEnum.Reporting:
                case DashboardComponentTypeEnum.AlarmDrawer:   
                case DashboardComponentTypeEnum.ImageView:                         
                case DashboardComponentTypeEnum.Mapping: 

                    if (component.objectID) {
                        component.groupID = component.objectID;
                        component.contextObject = {
                            id: component.objectID,
                            objectType: eLynxObjectTypeEnum.Group
                        };
                    } else {
                        component.groupID = contextGroupID;
                        component.contextObject = contextObject;
                    }

                    
                    break;

                    case DashboardComponentTypeEnum.DeviceMarketingReport: {

                        const marketingReport = component as IDeviceMarketingReportDashboardComponent;

                        if (groupLevel && marketingReport.objectID) {
                            //marketingReport.groupID = marketingReport.groupID;
                            marketingReport.contextObject = {
                                id: marketingReport.objectID,
                                objectType: eLynxObjectTypeEnum.Device
                            };
                        } else {
                            marketingReport.groupID = contextGroupID;
                            marketingReport.contextObject = contextObject;
                        }

                    }
                    break;

                case DashboardComponentTypeEnum.TagValueList: {
                        component.groupID = contextGroupID;

                        const tagValueComponent = component as ITagValueListDashboardComponent;
                        tagValueComponent.configuration.forEach(o => {
                            o.objects = [contextObject!];
                        });
                    }
                    break;

                case DashboardComponentTypeEnum.TankBattery: {
                    //component.groupID = contextGroupID;


                    if (component.objectID && component.objectType) {
                        component.groupID = contextGroupID;                        
                        component.contextObject = {
                            id: component.objectID,
                            objectType: component.objectType
                        };
                    } else {
                        component.contextObject = contextObject;
                    }                            

                    break;
                }

                default: {
                    component.groupID = contextGroupID;

                    if (groupLevel && component.objectID && component.objectType) {
                        component.contextObject = {
                            id: component.objectID,
                            objectType: component.objectType
                        };
                    } else {
                        component.contextObject = contextObject;
                    }                            
                }
            }


        });
      }


      const updatedItem = _.cloneDeep(item);

      updateDefinition(updatedItem.layout, updatedItem.templateObjectType === DashboardTemplateObjectTypeEnum.Group)

      return updatedItem;
  },
  clearMaximizeView: (item: IDashboardTemplateDefinition): IDashboardTemplateDefinition => {

    //   function updateColumns(section: IDashboardSection) {



    //     section.rows.forEach(row => {
    //         row.columns.forEach(column => {
    //             column.maximized = false;
    //             column.components
    //                 .filter(o => o.componentType === DashboardComponentTypeEnum.Section)
    //                 .forEach(component => {
    //                     updateColumns(component as IDashboardSection)
    //             });
    //         });
    //     });
    //   }

      const updatedItem = _.cloneDeep(item);

      updatedItem.layout.forEach(o => {
        o.maximized = false;
      });


      //updateColumns(updatedItem.section)

      return updatedItem;
  }    

  


}

export default DashboardRunnerUtils;
